import { useRef, useState, useEffect } from "react";
import * as XLSX from "xlsx-js-style";
import { Menu } from "primereact/menu";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SharedButton from "../../components/Shared/SharedButton";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { getOneMonthAgo } from "../CashInflow/CashInflow";
import AutoCompleteField from "../../components/Shared/AutoCompleteField";
import DatePicker from "../../components/Shared/DatePicker";
import toast from "react-hot-toast";
import CustomTable from "../../components/Shared/CustomTable";
import useFetchData from "../../hooks/useFetchData";
import { sequenceBodyTemplate } from "../../business/BusinessTable";
import moment from "moment";
import { Accordion, AccordionTab } from "primereact/accordion";
import { FaFileExport, FaMoneyBill } from "react-icons/fa6";
import SharedTooltip from "../../components/Shared/SharedTooltip";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { EyeIcon } from "../../components/Shared/TableActionIcons";
export default function Ledger() {
  const { user } = useSelector((state) => state.auth);
  const [endDate, setEndDate] = useState(
    new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0],
  );
  const [startDate, setStartDate] = useState(getOneMonthAgo(endDate));
  const [selectedAccount, setSelectedAccount] = useState(null);
  const { data: ledgerList, loading: isLoading, executeFetch } = useFetchData();

  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const [printLoading, setPrintLoading] = useState(false);
  const [activeTab1, setActiveTab1] = useState({});
  const menuRef = useRef(null);
  const balanceSheetRef = useRef(null);
  const iframeRef = useRef(null);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const lang = i18next.language;

  const handleSubmit = () => {
    if (!selectedAccount || !selectedAccount?.value) {
      toast.error("Please select an account");
      return;
    }
    if (startDate && endDate) {
      executeFetch(
        "POST",
        `listLedgers?account_code=${selectedAccount?.value}&start_date=${startDate}&end_date=${endDate}`,
      );
    }
  };
  const handleReset = () => {
    const today = new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000,
    )
      .toISOString()
      .split("T")[0];
    const defaultStartDate = getOneMonthAgo(today);
    setEndDate(today);
    setStartDate(defaultStartDate);
    setSelectedAccount(null);
    executeFetch(
      "POST",
      `listLedgers?account_code=&start_date=${defaultStartDate}&end_date=${today}`,
    );
  };

  // useEffect(() => {
  //   executeFetch("POST", `listLedgers?account_code=&start_date=${startDate}&end_date=${endDate}`);
  // }, [executeFetch])

  const handlePrint = () => {
    setPrintLoading(true);
    const groupIndexes = ledgerList?.groups?.map((_, i) => i);
    setActiveIndex(groupIndexes);

    const allNestedTabs = {};
    ledgerList?.groups?.forEach((group, groupIndex) => {
      const accCount = group?.accounts?.length || 0;
      allNestedTabs[groupIndex] = Array.from({ length: accCount }, (_, i) => i);
    });
    setActiveTab1(allNestedTabs);

    setTimeout(() => {
      const direction = lang === "ar" ? "rtl" : "ltr";
      const iframe = iframeRef.current;
      const doc = iframe.contentWindow.document;

      const businessNameEn = user?.Business?.name_en || "";
      const businessNameAr = user?.Business?.name_ar || "";
      const businessAddress = user?.Business?.address || "Saudi Arabia";
      const userEmail = user?.email || "";
      const userMobile = user?.mobile_number || "";
      const businessLogo = user?.Business?.logo || user?.Business?.logo_url;
      const crNumber = user?.Business?.cr_number || "";
      const licenseNo = user?.Business?.license_number || "";

      const thStyle =
        "border: 1px solid #d1d5db; padding: 7px 10px; text-align: center; font-weight: 600; font-size: 11px; background-color: #d1d5db;";
      const tdStyle =
        "border: 1px solid #d1d5db; padding: 7px 10px; text-align: center; font-size: 11px;";

      // Build all groups HTML
      const groupsHTML = (ledgerList?.groups || [])
        .map((group) => {
          const accountsHTML = (group?.accounts || [])
            .map((acc) => {
              const accountName =
                lang === "ar"
                  ? acc?.account?.name_code_ar
                  : acc?.account?.name_code_en;
              const closingBalance = acc?.closing_balance
                ? acc.closing_balance.toFixed(2)
                : "0";

              const entriesHTML = (acc?.ledger_entries || [])
                .map((entry, idx) => {
                  const isDebit = entry?.EntryType?.toLowerCase() === "debit";
                  const debit = isDebit ? (entry?.Amount ?? 0) : 0;
                  const credit = !isDebit ? (entry?.Amount ?? 0) : 0;
                  const rowBg = idx % 2 === 0 ? "#fff" : "#f9fafb";
                  return `
              <tr style="background:${rowBg};">
                <td style="${tdStyle}">${moment(entry.updated_at).format("DD-MM-YYYY")}</td>
                <td style="${tdStyle}">${entry?.JournalNumber ?? ""}</td>
                <td style="${tdStyle}; text-align:left;">${entry?.description ?? ""}</td>
                <td style="${tdStyle}">${debit} ${t("SAR")}</td>
                <td style="${tdStyle}">${credit} ${t("SAR")}</td>
                <td style="${tdStyle}">${entry?.Balance ?? ""}</td>
              </tr>
            `;
                })
                .join("");

              return `
            <div style="margin-bottom: 16px;">
              <div style="display:flex; justify-content:space-between; align-items:center; background:#f3f4f6; border:1px solid #d1d5db; border-bottom:none; padding: 7px 12px; font-weight:600; font-size:13px;">
                <span>${accountName}</span>
                <span>${t("Closing Balance")}: ${closingBalance} ${t("SAR")}</span>
              </div>
              <table style="width:100%; border-collapse:collapse; font-family:sans-serif;">
                <thead>
                  <tr>
                    <th style="${thStyle}">${t("entry_date")}</th>
                    <th style="${thStyle}">${t("entry_number")}</th>
                    <th style="${thStyle}; text-align:left;">${t("description")}</th>
                    <th style="${thStyle}">${t("total_debit")}</th>
                    <th style="${thStyle}">${t("total_credit")}</th>
                    <th style="${thStyle}">${t("Balance")}</th>
                  </tr>
                </thead>
                <tbody>
                  ${entriesHTML || `<tr><td colspan="6" style="${tdStyle} text-align:center; color:#6b7280;">-</td></tr>`}
                </tbody>
              </table>
            </div>
          `;
            })
            .join("");

          return `
          <div style="margin-bottom: 28px;">
            <div style="background-color:#d1d5db; padding:9px 12px; font-weight:700; font-size:15px; border:1px solid #d1d5db; border-bottom:none; border-radius:4px 4px 0 0; text-transform:capitalize;">
              ${t(group?.account_type)}
            </div>
            ${accountsHTML}
          </div>
        `;
        })
        .join("");

      doc.open();
      doc.write(
        `<html><head><title>Ledger Report</title><style>@media print {@page {size: A4 landscape; margin: 15mm;} body {margin: 0; padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; font-family: 'Inter', sans-serif; direction: ${direction};} header, footer {display: none;} tr {page-break-inside: avoid;}}</style></head><body style="font-family:sans-serif; direction:${direction}">`,
      );

      // 3-Column Business Header
      doc.write(`
      <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 20px; border-bottom: 2px solid #ccc; padding-bottom: 10px;">
        
        <!-- Column 1: Contact Info -->
        <div style="flex: 1; text-align: start; font-size: 13px; color: #333; line-height: 1.6;">
          ${businessAddress ? `<div><span style="font-weight: bold;">${t("Address")}:</span> ${businessAddress}</div>` : ""}
          ${userMobile ? `<div><span style="font-weight: bold;">${t("Phone")}:</span> ${userMobile}</div>` : ""}
          ${userEmail ? `<div><span style="font-weight: bold;">${t("Email")}:</span> ${userEmail}</div>` : ""}
        </div>

        <!-- Column 2: Logo and Main Info (Center) -->
        <div style="flex: 1; text-align: center;">
          ${businessLogo ? `<img src="${businessLogo}" style="height: 75px; margin-bottom: 8px; object-fit: contain;" />` : ""}
          ${businessNameEn ? `<div style="font-weight: bold; font-size: 18px; color: #1f2937;">${businessNameEn}</div>` : ""}
          ${businessNameAr && businessNameAr !== businessNameEn ? `<div style="font-weight: bold; font-size: 18px; color: #1f2937;">${businessNameAr}</div>` : ""}
          <div style="font-weight: bold; font-size: 16px; color: #1f2937; margin-top: 8px;">${t("Ledger Report")}</div>
          <div style="font-size: 12px; color: #555; margin-top: 5px;">${t("From")}: ${startDate} - ${t("To")}: ${endDate}</div>
        </div>

        <!-- Column 3: Contact Info (Mirrored) -->
        <div style="flex: 1; text-align: end; font-size: 13px; color: #333; line-height: 1.6;">
          ${businessAddress ? `<div><span style="font-weight: bold;">${t("Address")}:</span> ${businessAddress}</div>` : ""}
          ${userMobile ? `<div><span style="font-weight: bold;">${t("Phone")}:</span> ${userMobile}</div>` : ""}
          ${userEmail ? `<div><span style="font-weight: bold;">${t("Email")}:</span> ${userEmail}</div>` : ""}
        </div>
        
      </div>
      `);

      doc.write(groupsHTML);
      doc.write("</body></html>");
      doc.close();
      setPrintLoading(false);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;
        printWindow.print();
        printWindow.onafterprint = () => {
          setActiveIndex([]);
          setActiveTab1({});
        };
      };
    }, 2000);
  };

  const handleExcelExport = () => {
    const wb = XLSX.utils.book_new();

    const reportTitle = t("Ledger Report") || "Ledger Report";
    const dateRange =
      startDate || endDate
        ? `${t("From")}: ${startDate || ""}  -  ${t("To")}: ${endDate || ""}`
        : "";
    const businessNameEn = user?.Business?.name_en || "";
    const businessNameAr = user?.Business?.name_ar || "";
    const displayBusinessName =
      lang === "ar"
        ? businessNameAr || businessNameEn
        : businessNameEn || businessNameAr;

    ledgerList?.groups?.forEach((group) => {
      const sheetData = [];
      const groupName = group.account_type;

      const headerAoa = [
        [`${displayBusinessName}`],
        [`${reportTitle} - ${t(groupName)}`],
        [`${dateRange}`],
        [],
      ];

      sheetData.push(...headerAoa);

      const cellStyles = [];

      group.accounts.forEach((account) => {
        const acc = account.account;
        const accountName = `${lang === "ar" ? acc.name_code_ar : acc.name_code_en}`;

        sheetData.push([
          `${t("Account")}: ${accountName}   |   ${t("Closing Balance")}: ${account.closing_balance}`,
        ]);
        cellStyles.push({ r: sheetData.length - 1, type: "account_header" });

        sheetData.push([
          t("entry_date"),
          t("entry_number"),
          t("description"),
          t("total_debit"),
          t("total_credit"),
          t("Balance"),
        ]);
        cellStyles.push({ r: sheetData.length - 1, type: "table_header" });

        account?.ledger_entries?.forEach((entry) => {
          const date = moment(entry.updated_at).format("DD-MM-YYYY HH:mm:ss");
          const isDebit = entry.EntryType.toLowerCase() === "debit";
          const debit = isDebit ? entry.Amount : 0;
          const credit = !isDebit ? entry.Amount : 0;

          sheetData.push([
            date,
            entry.JournalNumber,
            entry.description,
            debit,
            credit,
            entry.Balance,
          ]);
        });
        sheetData.push([]);
      });

      const ws = XLSX.utils.aoa_to_sheet(sheetData);

      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 5 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 5 } },
      ];

      for (let r = 0; r < 3; r++) {
        const cellRef = XLSX.utils.encode_cell({ c: 0, r });
        if (ws[cellRef]) {
          ws[cellRef].s = {
            font: { bold: true, sz: r === 0 ? 16 : 14 },
            alignment: { horizontal: "center", vertical: "center" },
          };
        }
      }

      const borderStyle = {
        top: { style: "thin", color: { rgb: "9CA3AF" } },
        bottom: { style: "thin", color: { rgb: "9CA3AF" } },
        left: { style: "thin", color: { rgb: "9CA3AF" } },
        right: { style: "thin", color: { rgb: "9CA3AF" } },
      };

      cellStyles.forEach((styleInfo) => {
        if (styleInfo.type === "account_header") {
          ws["!merges"].push({
            s: { r: styleInfo.r, c: 0 },
            e: { r: styleInfo.r, c: 5 },
          });
          const cellRef = XLSX.utils.encode_cell({ c: 0, r: styleInfo.r });
          if (ws[cellRef]) {
            ws[cellRef].s = {
              fill: { patternType: "solid", fgColor: { rgb: "E5E7EB" } },
              font: { bold: true, sz: 12 },
              alignment: { horizontal: "center", vertical: "center" },
              border: borderStyle,
            };
          }
        } else if (styleInfo.type === "table_header") {
          for (let c = 0; c < 6; c++) {
            const cellRef = XLSX.utils.encode_cell({ c, r: styleInfo.r });
            if (ws[cellRef]) {
              ws[cellRef].s = {
                fill: { patternType: "solid", fgColor: { rgb: "D1D5DB" } },
                font: { bold: true },
                alignment: { horizontal: "center", vertical: "center" },
                border: borderStyle,
              };
            }
          }
        }
      });

      // Added border styles and left/right alignments for regular rows underneath table headers
      for (let r = 4; r < sheetData.length; r++) {
        for (let c = 0; c < 6; c++) {
          const cellRef = XLSX.utils.encode_cell({ c, r });
          if (!ws[cellRef]) {
            ws[cellRef] = { v: "", t: "s" };
          }
          if (!ws[cellRef].s) ws[cellRef].s = {};
          if (!ws[cellRef].s.border) ws[cellRef].s.border = borderStyle;

          if (!ws[cellRef].s.alignment) {
            ws[cellRef].s.alignment = {
              horizontal: c >= 3 ? "right" : "left",
              vertical: "center",
            };
          }
        }
      }

      ws["!cols"] = [
        { wch: 20 },
        { wch: 15 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, groupName.substring(0, 31));
    });

    try {
      XLSX.writeFile(wb, "Ledger_Report.xlsx");
    } catch (error) {
      console.error("Error writing Excel file:", error);
    }
  };

  const extractCategoryData = (ledgerList, category) => {
    const categoryData = ledgerList[category];
    const headers = [
      "Account",
      "Balance",
      "ID",
      "Name AR",
      "Name EN",
      "Sub-Ledger Date",
      "Sub-Ledger Debit",
      "Sub-Ledger Credit",
      "Sub-Ledger Description",
    ];
    const data = [headers];

    categoryData.accounts.forEach((account) => {
      const accountData = [
        account.account.name_ar,
        account.account.balance,
        account.account.id,
        account.account.name_ar,
        account.account.name_en,
        "",
        "",
        "",
        "",
      ];
      data.push(accountData);

      account.account.sub_ledgers.forEach((subLedger) => {
        const subLedgerData = [
          account.account.name_ar,
          account.account.balance,
          account.account.id,
          account.account.name_ar,
          account.account.name_en,
          subLedger.date,
          subLedger.debit,
          subLedger.credit,
          subLedger.description,
        ];
        data.push(subLedgerData);
      });
    });

    return data;
  };
  const sequenceBodyTemplate = (rowData, options) => {
    return options.rowIndex + 1;
  };
  const balanceBody = (data) => {
    return (
      <>
        {data} {t("SAR")}
      </>
    );
  };

  const tempelateBody = (rowData) => {
    return (
      <>
        {/* <SharedTooltip id='my-tooltip-1' content='view' />
        <MdOutlineRemoveRedEye
          size={25}
          data-tooltip-id='my-tooltip-1'
          className='table-icon'
          onClick={() => {
            navigate(`/manager/report/ledger-entries/${rowData?.JournalNumber}`)
          }}
        /> */}
        <EyeIcon
          onClick={() => {
            navigate(
              `/manager/report/ledger-entries/${rowData?.JournalNumber}`,
            );
          }}
          title={t("view")}
        />
      </>
    );
  };
  const LedgerTableColumns = [
    { body: tempelateBody, header: t("action") },
    {
      body: sequenceBodyTemplate,
      header: t("no"),
      style: { width: "3rem" },
    },
    {
      field: "date",
      header: t("entry_date"),
      body: (rowData) =>
        moment(rowData.updated_at).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      field: "JournalNumber",
      header: t("entry_number"),
    },
    {
      field: "total_debit",
      body: (row) =>
        row?.EntryType.toLowerCase() == "debit"
          ? balanceBody(row?.Amount)
          : `0 SAR`,
      header: t("total_debit"),
    },
    {
      field: "total_credit",
      body: (row) =>
        row?.EntryType.toLowerCase() == "credit"
          ? balanceBody(row?.Amount)
          : `0 SAR`,
      header: t("total_credit"),
    },
    {
      field: "description",
      header: t("description"),
    },
    {
      field: "Balance",
      header: t("Balance"),
    },
  ];

  const formatAccountOptions = (data) => {
    return data
      ? Object.entries(data).map(([id, account]) => ({
          value: Number(account?.code),
          label:
            lang === "ar"
              ? `${account.name_ar} ${account?.code}`
              : `${account.name_en} ${account?.code}`,
        }))
      : [];
  };

  return (
    <div>
      <div className="flex justify-end">
        <div className="w-full md:w-fit flex gap-2 flex-col sm:flex-row">
          <AutoCompleteField
            useFormik={false}
            placeholder={t("Select Account")}
            value={selectedAccount}
            onChange={(e) => setSelectedAccount(e.value)}
            fieldUrl="searchAllAccounts"
            optionsFormat={formatAccountOptions}
          />

          <DatePicker
            useFormik={false}
            value={startDate ? new Date(startDate) : null}
            onChange={(e) => {
              setStartDate(
                e.value
                  ? new Date(
                      e.value.getTime() - e.value.getTimezoneOffset() * 60000,
                    )
                      .toISOString()
                      .split("T")[0]
                  : "",
              );
            }}
          />
          <DatePicker
            useFormik={false}
            value={endDate ? new Date(endDate) : null}
            onChange={(e) => {
              setEndDate(
                e.value
                  ? new Date(
                      e.value.getTime() - e.value.getTimezoneOffset() * 60000,
                    )
                      .toISOString()
                      .split("T")[0]
                  : "",
              );
            }}
          />
          <div className="flex items-center justify-end gap-2">
            <SharedButton
              title={t("apply_filter")}
              icon="pi pi-filter"
              onClick={handleSubmit}
              loading={isLoading}
              disabled={!startDate || !endDate || !selectedAccount || isLoading}
            />
            <SharedButton
              title={t("Reset")}
              buttonType="reset"
              icon="pi pi-sync"
              onClick={handleReset}
            />
            <SharedButton
              title={t("Export Excel")}
              icon={"pi pi-file-excel"}
              iconSize={20}
              onClick={() => handleExcelExport()}
            />
            <SharedButton
              title={t("Export PDF")}
              icon={"pi pi-print"}
              iconSize={20}
              onClick={() => handlePrint()}
            />
          </div>
        </div>
      </div>
      <div className="this_div" ref={balanceSheetRef}>
        <div className="!pb-8">
          <div className="mt-5">
            <Accordion
              multiple
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              {ledgerList?.groups?.map((grp, index) => (
                <AccordionTab
                  key={index}
                  header={
                    <div className="flex items-center justify-between ">
                      <div className="flex items-center">
                        <div
                          className={`flex-shrink-0 p-1.5 bg-gray-100 rounded-lg text-white ${isRTL ? "ml-3" : "mr-3"}`}
                        >
                          <FaMoneyBill size={20} color="#0070C2" />
                        </div>
                        <div className="flex w-full justify-between items-center">
                          <h3 className="text-xl font-semibold text-gray-700 capitalize">
                            {t(grp?.account_type)}
                          </h3>
                        </div>
                      </div>
                    </div>
                  }
                  pt={{
                    header: {
                      className: `${
                        activeIndex == index
                          ? "bg-gray-200 mt-4"
                          : "bg-white mt-4"
                      }`,
                    },
                    headeraction: {
                      className: "shadow-none focus:shadow-none bg-transparent",
                    },
                    headerIcon: {
                      className:
                        isRTL &&
                        !(Array.isArray(activeIndex)
                          ? activeIndex.includes(index)
                          : activeIndex === index)
                          ? "rotate-180"
                          : "",
                    },
                  }}
                >
                  <Accordion
                    multiple
                    activeIndex={activeTab1[index] || []}
                    onTabChange={(e) => {
                      setActiveTab1((prev) => ({
                        ...prev,
                        [index]: e.index,
                      }));
                    }}
                  >
                    {grp?.accounts?.map((acc, accIndex) => (
                      <AccordionTab
                        key={accIndex}
                        header={
                          <div className="flex items-center justify-between w-full">
                            <h3>
                              {lang == "en"
                                ? acc?.account?.name_code_en
                                : acc?.account?.name_code_ar}
                            </h3>
                            <div className="mx-16 !mt-2 flex gap-2">
                              <span className="font-semibold text-black/70">{`${t(
                                "Closing Balance",
                              )}`}</span>
                              <span className="font-semibold text-black/60 ">
                                {acc?.closing_balance
                                  ? acc?.closing_balance?.toFixed(2)
                                  : "0"}{" "}
                                <span>{t("SAR")}</span>
                              </span>
                            </div>
                          </div>
                        }
                        pt={{
                          headerIcon: {
                            className:
                              isRTL &&
                              !(activeTab1[index] || []).includes(accIndex)
                                ? "rotate-180"
                                : "",
                          },
                        }}
                      >
                        <CustomTable
                          data={acc?.ledger_entries}
                          columns={LedgerTableColumns}
                        />
                      </AccordionTab>
                    ))}
                  </Accordion>
                </AccordionTab>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
      <iframe ref={iframeRef} style={{ display: "none" }}></iframe>
    </div>
  );
}
